import type { FaireProductEntity } from "../../entity_types/product";

export const p_pje42r6jef: FaireProductEntity = {
  token: "p_pje42r6jef",
  type: "product",
  name: "Vintage Black Cat Crew Socks",
  brandToken: "b_dskill7gu0",
  brandName: "FootClothes LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/b7bbb1e7f2bcaeb81e4019adf79523635034237d5547f0c5e35ecf7b31c547cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a51b7ef550c68d84a7da543cc9d4e24536439976f9bc8ac6fc3354bac8e84aeb.png",
    "https://cdn.faire.com/fastly/e2766b795b6394f35d3cbc391123b173a675607a947087b5c913668e991aad3f.jpeg",
    "https://cdn.faire.com/fastly/097188dc89a1214ed4621bdd29b60d59c405332e797648d01f7cb04f3b88b6e3.jpeg",
    "https://cdn.faire.com/fastly/f6a7537a7d662977e5324bb25b4864b68824b23fb6ff65cd02cdda9d9f1f8091.jpeg",
    "https://cdn.faire.com/fastly/c27a28a5cc7c50092d66a8f1f58ee5481111910867e6c404fef252e53c55bc66.jpeg",
    "https://cdn.faire.com/fastly/90b3c737defdf070e35b478187620d7d4bcff1b34a36e799994f05b9687213d3.jpeg",
    "https://cdn.faire.com/fastly/644467ee69630c906e534cc01ae461d6dd223565e10df53657ad9c72953c59b9.jpeg",
    "https://cdn.faire.com/fastly/087f255a576009cf9c093e96c4c6cff62958d7e3b8a9a556fe2db9558f8f4be0.png",
  ],
  priceDollars: 6,
  description:
    "Celebrate Halloween year round with these purrfectly cute vintage-inspired black cat crew socks. Best when worn while walking under ladders.\n\n-------\n\n𝐒𝐨𝐜𝐤 𝐒𝐩𝐞𝐜𝐬:\n\n• Combed Cotton/Nylon/Spandex for breathability, durability, and stretch\n• Double terry in the heel and toe area adds durability and comfort where most novelty sock brands fail.\n• 200N Thread Count for highest level of detail\n• 40 Gram Socks with smooth seams\n• No uncomfortable bumps in the toe area\n\nOne Size Fits Most Humans Size 5-13",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:43.439Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
